<template>
    <template v-if="form">
        <StepForm :form="form" v-if="form.type == 'step'" />
    <SimpleForm
            :form="form"
            v-if="form.type == 'simple'"
            @submitted="handleSubmitted"
        />
    </template>
</template>
<script setup>
import { defineAsyncComponent, provide } from "vue";

const SimpleForm = defineAsyncComponent(
    () => import("@components/Forms/SimpleForm.vue"),
);

const StepForm = defineAsyncComponent(
    () => import("@components/Forms/StepForm.vue"),
);

const props = defineProps({
    form: {
        type: Object,
    },
    title: {
        type: String,
        default: "",
    },
    description: {
        type: String,
        default: "",
    },
    showLegend: {
        type: Boolean,
        default: true,
    },
    formClass:{
        type: String,
        default: "flex flex-col gap-4",
    },
    fieldsetClass: {
        type: String,
    },
});

const emit = defineEmits(["submitted"]);

const handleSubmitted = () => {
    emit("submitted");
};

// Provided props
provide("title", props.title ?? "");
provide("description", props.description ?? "");
provide("showLegend", props.showLegend ?? false);
provide("formClass", props.formClass);
provide("fieldsetClass", props.fieldsetClass ?? false);
</script>
